import type { Landmark } from '../../../data/types';
import type { MeshBuilder } from '../../mesh/meshBuilder';
import { ringPoints, pyramidOverRing, frustumSolid } from '../solids';
import { rectWall, type MasonryStyles } from './masonry';
import { meshFrameOf, planFrameOf } from './planFrame';

/** The painted round quay tower: submerged masonry foot, two tiers of small windows and a cone. */
export function buildQuayTower(
  builder: MeshBuilder,
  landmark: Landmark,
  styles: MasonryStyles,
  elevation = 0
): void {
  styles = { ...styles, glazing: { reveal: styles.wall } };
  const frame = meshFrameOf(planFrameOf(landmark.footprint, landmark.heading));
  const radius = 4.2,
    eaves = 8.5;
  const ring = ringPoints([0, 0], radius, 12, 0);
  ring.forEach((a, i) => {
    const b = ring[(i + 1) % ring.length]!;
    const centre = Math.hypot(b[0] - a[0], b[1] - a[1]) / 2;
    const windows =
      i % 2 === 0
        ? [2, 5.5].map(
            (sill) =>
              [
                [centre - 0.35, sill],
                [centre + 0.35, sill],
                [centre + 0.35, sill + 1.2],
                [centre - 0.35, sill + 1.2],
              ] as const
          )
        : [];
    rectWall(builder, styles, frame, [a, b], [-0.2, eaves], windows, 0);
  });
  // The wider batter is part of the masonry foundation, rather than a house floating on water.
  frustumSolid(
    builder,
    styles.wall,
    frame,
    { center: [0, 0], radius: 4.7, segments: 12, phase: 0 },
    -2.5 - elevation,
    -0.2,
    radius,
    { top: false, bottom: true }
  );
  pyramidOverRing(builder, styles, frame, ring, eaves, { plan: [0, 0], y: 14 });
}
